/**
 * Created by fabianbr on 7/11/2017.
 */

export const APP_COUNTRY_LOCALSTORAGE_KEY = 'cgp_country';
export const US_STATES_LIST = {
    NEW_JERSEY: 'NJ',
    PENNSYLVANIA: 'PA',
    NEW_YORK: 'NY',
};

export const CANADA_STATES_LIST = {
    ONTARIO: 'ON'
};

export const COUNTRY_ISO3 = {
    CANADA: 'CAN'
}